import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsOfService: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#022334] text-white font-sans antialiased relative">
            {/* Optimized Background Container */}
            <div
                className="absolute left-0 right-0 top-0 pointer-events-none overflow-hidden"
                style={{
                    zIndex: 0,
                    bottom: 0,
                }}
            >
                {/* Unified Background SVG */}
                <div
                    className="w-full"
                    style={{
                        backgroundImage: 'url(/background/bg.svg)',
                        backgroundSize: '100% auto',
                        backgroundPosition: 'top center',
                        backgroundRepeat: 'no-repeat',
                        transform: 'translateZ(0)',
                        backfaceVisibility: 'hidden' as const,
                        willChange: 'transform',
                        minHeight: '100%',
                        paddingBottom: '344.2%',
                    }}
                />
            </div>

            {/* Content */}
            <div className="relative z-10">
                <Navbar />
                <main className="relative">
                    <section className="px-4 sm:px-8 lg:px-12 py-24">
                        <div className="container mx-auto max-w-[1700px]">
                            {/* Title */}
                            <h1
                                style={{
                                    fontFamily: 'Manrope',
                                    fontWeight: 500,
                                    fontSize: 'clamp(48px, 8vw, 128px)',
                                    lineHeight: 'clamp(60px, 9vw, 175px)',
                                    letterSpacing: '-0.05em',
                                    textAlign: 'center',
                                    color: '#FFFFFF',
                                    marginBottom: '24px',
                                }}
                            >
                                Terms of Service
                            </h1>

                            {/* Last Updated */}
                            <p
                                style={{
                                    fontFamily: 'Manrope',
                                    fontWeight: 200,
                                    fontSize: 'clamp(24px, 3vw, 45px)',
                                    lineHeight: 'clamp(32px, 4vw, 61px)',
                                    textAlign: 'center',
                                    letterSpacing: '-0.05em',
                                    color: '#FFFFFF',
                                    marginBottom: '48px',
                                }}
                            >
                                Last updated: Oct.31, 2025
                            </p>

                            {/* Intro Text */}
                            <p
                                style={{
                                    fontFamily: 'Manrope',
                                    fontWeight: 200,
                                    fontSize: 'clamp(16px, 1.5vw, 24px)',
                                    lineHeight: '120%',
                                    textAlign: 'center',
                                    color: '#C0C0BF',
                                    maxWidth: '1545px',
                                    margin: '0 auto 80px',
                                }}
                            >
                                By accessing or using Hush's platform and services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any part of these terms, you may not use our services. Please read this carefully to understand your rights and obligations.
                            </p>

                            {/* Content */}
                            <div
                                style={{
                                    fontFamily: 'Manrope',
                                    fontSize: '16px',
                                    lineHeight: '160%',
                                    color: '#C0C0BF',
                                }}
                            >
                                {/* Agreement to Terms */}
                                <section style={{ marginBottom: '80px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Agreement to Terms
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1609px', margin: '0 auto' }}>
                                        By accessing or using Hush's platform and services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any part of these terms, you may not use our services. These terms apply to all users of the platform, including candidates, employers, and visitors. You must be at least 18 years old and have the legal capacity to enter into contracts to use our services.
                                    </p>
                                </section>

                                {/* Use of Services */}
                                <section style={{ marginBottom: '80px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 700,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Use of Services
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1609px', margin: '0 auto' }}>
                                        You agree to provide accurate, current, and complete information when using our services. You must maintain and update your information to keep it accurate and maintain the security of your account credentials. You accept responsibility for all activities under your account. You agree not to provide false or misleading information, use the service for any illegal purpose, violate any applicable laws or regulations, infringe on the intellectual property rights of others, harass or harm other users, attempt to gain unauthorized access to our systems, or use automated systems to access the platform without permission.
                                    </p>
                                </section>

                                {/* Candidate Terms */}
                                <section style={{ marginBottom: '80px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 600,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Candidate-Specific Terms
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1693px', margin: '0 auto' }}>
                                        Your profile will only be shared with employers after you provide explicit consent. You can control which companies can view your profile through your account settings. Sign-on bonuses and referral bonuses are subject to eligibility requirements and verification. Payment will be made after successful placement and completion of any required onboarding period. You maintain control over your information and can update your privacy preferences at any time.
                                    </p>
                                </section>

                                {/* Employer Terms */}
                                <section style={{ marginBottom: '80px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 600,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Employer-Specific Terms
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1693px', margin: '0 auto' }}>
                                        Employers agree to provide accurate job descriptions and comply with all applicable employment laws. All postings must be for legitimate job opportunities. Employers must handle candidate information in accordance with applicable privacy laws and use it solely for recruitment purposes related to their organization. Fees are based on qualified candidates as outlined in your service agreement. Payment terms will be specified in separate documentation.
                                    </p>
                                </section>

                                {/* Intellectual Property */}
                                <section style={{ marginBottom: '80px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 600,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Intellectual Property
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1700px', margin: '0 auto' }}>
                                        The Hush platform, including all content, features, and functionality, is owned by Hush and protected by intellectual property laws. You may not copy, modify, distribute, or create derivative works without our explicit permission. All trademarks, service marks, and logos displayed on the platform are the property of Hush or their respective owners.
                                    </p>
                                </section>

                                {/* Limitation of Liability */}
                                <section style={{ marginBottom: '80px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 600,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Limitation of Liability
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1700px', margin: '0 auto' }}>
                                        Hush provides the platform "as is" without warranties of any kind. We are not responsible for the accuracy of user-provided information, the outcome of any job search or hiring process, actions or decisions made by employers or candidates, or any indirect, incidental, or consequential damages. Your use of the service is at your own risk.
                                    </p>
                                </section>

                                {/* Termination */}
                                <section style={{ marginBottom: '80px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 600,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Termination
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1700px', margin: '0 auto' }}>
                                        We reserve the right to suspend or terminate your account at any time for violation of these terms or for any other reason. You may terminate your account at any time through your account settings. Upon termination, your right to use the service will immediately cease.
                                    </p>
                                </section>

                                {/* Changes to Terms */}
                                <section style={{ marginBottom: '80px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 600,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Changes to Terms
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1700px', margin: '0 auto' }}>
                                        We may update these Terms of Service from time to time. We will notify you of any material changes by email or through the platform. Continued use of our services after such changes constitutes acceptance of the new terms.
                                    </p>
                                </section>

                                {/* Contact */}
                                <section style={{ marginBottom: '48px' }}>
                                    <h2
                                        style={{
                                            fontFamily: 'Manrope',
                                            fontWeight: 600,
                                            fontSize: 'clamp(28px, 3vw, 47px)',
                                            lineHeight: '100%',
                                            textAlign: 'center',
                                            color: '#D9D9D9',
                                            marginBottom: '32px',
                                        }}
                                    >
                                        Contact Us
                                    </h2>
                                    <p style={{ marginBottom: '0', textAlign: 'center', fontWeight: 200, maxWidth: '1700px', margin: '0 auto' }}>
                                        If you have questions about these Terms of Service, please contact us at <a href="mailto:legal@hushtalent.io" style={{ color: '#6AD4FF', textDecoration: 'underline' }}>legal@hushtalent.io</a>.
                                    </p>
                                </section>
                            </div>
                        </div>
                    </section>
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default TermsOfService;
